import { attachment } from '../attachment/attachment.model';
import { Contact } from './contact.model';

export class BatchEmail {
  subject: string;
  body: string;
  senderName: string;
  senderEmail: string;
  attachments: attachment[];
  members: number[];
  scheduleTime: Date;
}

export class DirectBatchEmail {
  subject: string;
  body: string;
  senderName: string;
  senderEmail: string;
  attachments: attachment[];
  contacts: Contact[];
  scheduleTime: Date;
}
